import { create } from "zustand";

interface SelectionStore {
  checkedIds: Set<string>;
  selectAllFilteredMode: boolean;
  selectAllFilteredCount: number;
  toggleOne: (id: string) => void;
  toggleAll: (pageIds: string[]) => void;
  setSelectAllFiltered: (count: number) => void;
  clearAll: () => void;
}

export const useSelectionStore = create<SelectionStore>((set) => ({
  checkedIds: new Set<string>(),
  selectAllFilteredMode: false,
  selectAllFilteredCount: 0,

  toggleOne: (id) =>
    set((state) => {
      const next = new Set(state.checkedIds);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return { checkedIds: next, selectAllFilteredMode: false, selectAllFilteredCount: 0 };
    }),

  toggleAll: (pageIds) =>
    set((state) => {
      const allChecked = pageIds.every((id) => state.checkedIds.has(id));
      if (allChecked) {
        const next = new Set(state.checkedIds);
        pageIds.forEach((id) => { next.delete(id); });
        return { checkedIds: next, selectAllFilteredMode: false, selectAllFilteredCount: 0 };
      }
      const next = new Set(state.checkedIds);
      pageIds.forEach((id) => { next.add(id); });
      return { checkedIds: next };
    }),

  setSelectAllFiltered: (count) =>
    set({ selectAllFilteredMode: true, selectAllFilteredCount: count }),

  clearAll: () =>
    set({ checkedIds: new Set<string>(), selectAllFilteredMode: false, selectAllFilteredCount: 0 }),
}));
